import { Injectable } from "@angular/core";
import { Http, RequestOptions, Headers, Response } from "@angular/http";
import { Router } from "@angular/router";
import { API_URL } from "../../../config/app.config";
// import { ContentModel } from "../models/content.model";
import "rxjs";
import { Subject } from "rxjs/Subject";

@Injectable()
export class DataService {

  dataServiceArrived: Subject<{Type: string; Content: string}[]> = new Subject();

  private options: RequestOptions;
  private data : {Type:string, Content: string}[] = [];
  public dataLoaded: boolean = false;

  constructor(private http: Http, private router: Router) {
    this.options = new RequestOptions();
    this.options.withCredentials = true;
    this.options.headers = new Headers({'Content-type': 'application/json'});
    this.getContentList().subscribe((data) =>
    {
      this.data = data;
      this.dataLoaded = true;
      this.dataServiceArrived.next(this.data.slice());
    });
  }

  getContentList() {
    return this.http.get(API_URL + '/contentfiles', this.options)
      .map((response: Response) => {
        return response.json().Content;
      });
  }

  getContent()
  {
    if (!this.dataLoaded)
    {
      this.getContentList();
    }
    else {
      this.dataServiceArrived.next(this.data.slice());
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/main/services/dataservice.service.ts